import React, { useState, useEffect } from "react";
// import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import MergeTypeIcon from '@mui/icons-material/MergeType';

import "./ScrollTopButton.css";

const ScrollTopButton = () => {
    const [showTopBtn, setShowTopBtn] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);
    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    return (
        <div className="top-to-btm">
            {" "}
            {showTopBtn && (
                <MergeTypeIcon
                    className="icon-position icon-style"
                    onClick={goToTop}
                    style={{fontSize:'40px'}}
                />
            )}{" "}
        </div>
    );
};
export default ScrollTopButton;